import React from 'react'

const about = () => {
    return (
        <section id="about">
            <div className="row">
                <div className="three columns">
                    <img className="profile-pic" src="images/profilepic.jpg" />
                </div>
                <div className="nine columns main-col">
                    <h2>About Me</h2>
                    <p style={{color: '#ffffff', fontSize: 17}}>
                        I am a self-taught software engineer who started learning at a fast paced startup, with 5+ years of experience. 
                        Because of my ambitious nature and as someone who enjoys taking on challenges, development comes to me naturally. 
                        I'm adept in debugging and
                        rewriting complicated legacy systems. I have a good deal of experience in collaborating with
                        product managers, and customers for product development.
                    </p>
                    <div className="row">
                            <p>
                                <a href="/doc/resume.pdf" className="button" style={{marginRight: 3}}><i className="fa fa-download" /> Download Resume</a>
                                <a target="_blank" href="https://lukejsimonetti.com/" className="button"><i className="fa fa-file-o" /> View Recent Work</a>
                            </p>
                    </div> {/* end row */}
                </div> {/* end .main-col */}
            </div>
        </section>
    )
}

export default about


// WEBPACK FOOTER //
// ./src/main/about.js